import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import NavigatorButton from '../NavigatorButton'
import { PageNavigator, StyledHr } from '../component.styles'
import { stepDataMap } from '../data'

const StepPageNavigator = ({
  activeStep,
  goalsAreCompleted,
  implementationApproachIsCompleted,
  onStepClick,
  purposeIsCompleted,
}) => {
  const stepCompletionStatus = [
    implementationApproachIsCompleted,
    goalsAreCompleted,
    purposeIsCompleted,
  ]

  return (
    <PageNavigator>
      {Object.values(stepDataMap).map((step, index) => (
        <Fragment key={step.modalName}>
          {index > 0 && <StyledHr />}
          <NavigatorButton
            isActive={activeStep === index}
            isCompleted={stepCompletionStatus[index]}
            label={step.label}
            onClick={() => onStepClick(index)}
          >
            {step.label}
          </NavigatorButton>
        </Fragment>
      ))}
    </PageNavigator>
  )
}

StepPageNavigator.propTypes = {
  activeStep: PropTypes.number,
  goalsAreCompleted: PropTypes.bool,
  implementationApproachIsCompleted: PropTypes.bool,
  onStepClick: PropTypes.func,
  purposeIsCompleted: PropTypes.bool,
}

export default StepPageNavigator
